module.exports = __webpack_public_path__ + "img/avatar-52.423c195c.png";